import React from 'react';

import './Toggle.scss';

export default (props) => {
  const { identifier, checked, disabled, onChange, onClick, label, className } =
    props;

  return (
    <div
      className={[
        'custom-control custom-switch mt-2 bo-toggle',
        className || '',
      ].join(' ')}
    >
      <input
        type="checkbox"
        className="custom-control-input"
        name={`${identifier || ''}-toggle-component`}
        id={`${identifier || ''}-toggle-component`}
        checked={checked === true}
        disabled={disabled === true}
        onChange={onChange || (() => {})}
        onClick={onClick || (() => {})}
      />
      <label
        className="custom-control-label bot-control-label"
        htmlFor={`${identifier || ''}-toggle-component`}
      >
        {label}
      </label>
    </div>
  );
};
